var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "560px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-icon', _vm._g(_vm._b({
          ref: "bottom-popup-button",
          attrs: {
            "small": "",
            "color": "warning darken-1"
          }
        }, 'v-icon', attrs, false), on), [_vm._v("mdi-star-circle-outline")])];
      }
    }]),
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('v-card', {
    staticClass: "bottom-popup-card",
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "bottom-popup-card__img"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/member/starbucks.svg",
      "alt": "starbucks"
    }
  })])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-16 text-md-14 color-gray-7e text-center"
  }, [_vm._v(" 회원가입 완료 후 전문가 DB에 전문가 이력을 등록하시는 회원모두에게 스타벅스 쿠폰을 증정합니다. ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', [_c('v-stepper', {
    staticClass: "bottom-popup-stepper row justify-center align-center elevation-0",
    attrs: {
      "alt-labels": ""
    }
  }, _vm._l(_vm.steps, function (step, i) {
    return _c('v-stepper-step', {
      key: i,
      staticStyle: {
        "white-space": "pre-line"
      },
      attrs: {
        "step": i + 1,
        "complete-icon": "mdi-numeric-".concat(i + 1),
        "complete": "",
        "color": "secondary"
      }
    }, [_vm._v(" " + _vm._s(step) + " ")]);
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }